import './PinpointPageModals.scss';

import React from 'react';
import moment from 'moment';

import Modal from 'components/Modal';
import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';
import Thumbnail from 'components/Thumbnail';

export default class BeaconDetailsModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        deletePinpoint: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        pinpoint: React.PropTypes.object.isRequired,
        show: React.PropTypes.bool.isRequired
    };

    render() {
        let { closeModal, pinpoint, show } = this.props;

        if(Object.keys(pinpoint).length > 0 && pinpoint.id != null) {
            return (
                <Modal show={show}
                       className="pinpoint-details"
                       handleClose={closeModal.bind(this)}>
                    <header className="pinpoint-details__header modal__header">
                        <div className="pinpoint-details__thumbnail modal__thumbnail">
                            {pinpoint.thumbnail ? (
                                <div className="modal__thumbnail--image pinpoint-details__thumbnail--image">
                                    <img src={`${process.env.API_URL}rest/file/${pinpoint.thumbnail.id}`} alt={pinpoint.name} />
                                </div>
                            ) : (
                                <Thumbnail defaultAvatar="bluetooth"
                                           thumbnailID={null} />
                            )}
                        </div>
                    </header>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            Name: {pinpoint.name}
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            Type: {pinpoint.type === 'uuid' ? 'Beacon' : 'GPS'}
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            Created by {pinpoint.creator.firstName} {pinpoint.creator.lastName} | {moment(pinpoint.created).format('MM/DD/YY')}
                        </div>
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            UUID:
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            {pinpoint.beaconId}
                        </div>
                        <div className="pinpoint-details__name modal__name modal__name--secondary">
                            MAJOR: <strong>{pinpoint.major}</strong> | MINOR: <strong>{pinpoint.minor}</strong>
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            Broadcast: <strong className="pinpoint-details__broadcast-value">{pinpoint.broadcast}</strong>
                        </div>
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            Notification
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            {pinpoint.notificationMessage || '[No Notification Specified]'}
                        </div>
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            Notes
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            {pinpoint.notes || '[No notes]'}
                        </div>
                    </div>
                    <SlideList className="pinpoint-details__assignments-list pinpoint-details__list details-modal__list"
                               count={pinpoint.assignmentIds.length}
                               icon="assignments"
                               items={pinpoint.assignments || []}
                               title="Assignments"
                               type="assignments--names-only" />

                    <div className="modal__buttons">
                        {/*<ModalButton disabled={isSaving === true}
                                     icon="edit"
                                     onClick={openModal.bind(this, MODALS.PINPOINT_EDIT)}
                                     text="Edit" />
                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deletePinpoint.bind(this, pinpoint)}
                                     text="Delete" />*/}
                        <ModalButton icon="check"
                                     onClick={closeModal.bind(this)}
                                     text="Done" />
                    </div>
                </Modal>
            );
        } else {
            return null;
        }
    }
}




// WEBPACK FOOTER //
// ./src/containers/PinpointsPage/modals/BeaconDetailsModal.js